import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/key-groups`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  readAll({ commit }, payload: {
    page: number,
    itemsPerPage: number,
    search?: string,
    buildingId?: number,
  }) {
    return axiosInstance.get(`${baseUrl}`, { params: payload })
      .then((data) => data.data);
  },
  drop({commit}, payload: {
    token: string,
    keyGroupId: number,
    keyStatus: string,
    estimatedEndDate: string,
    dropFromRelay: boolean,
    giveToUserId: number,
    referentId: number,
  }) {
    return axiosInstance.get(`${baseUrl}/${payload.keyGroupId}/drop`, {
      params: {
        token: payload.token,
        keyStatus: payload.keyStatus,
        estimatedEndDate: payload.estimatedEndDate,
        dropFromRelay: payload.dropFromRelay,
        giveToUserId: payload.giveToUserId,
        referentId: payload.referentId,
      },
    }).then((data) => data.data);
  },
  withdraw({commit}, payload: {
    token: string,
    keyGroupId: number,
    keyStatus: string,
    estimatedEndDate: string,
    dropFromRelay: boolean,
    giveToUserId: number,
    referentId: number,
  }) {
    return axiosInstance.get(`${baseUrl}/${payload.keyGroupId}/withdraw`, {
      params: {
        token: payload.token,
        keyStatus: payload.keyStatus,
        estimatedEndDate: payload.estimatedEndDate,
        dropFromRelay: payload.dropFromRelay,
        giveToUserId: payload.giveToUserId,
        referentId: payload.referentId,
      },
    }).then((data) => data.data);
  },
  deleteById({commit}, payload: { id: number }) {
    return axiosInstance.delete(`${baseUrl}/${payload.id}`).then((data) => data.data);
  },
  getById({commit}, payload: { id: number }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}`).then((data) => data.data);
  },
  getKeysInGroup({commit}, payload: {id: number, params: object}) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/keys`, {params: payload?.params})
      .then((data) => data.data);
  },
  getKeysFollowedStatus({commit}, payload: {id: number}) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/keys-followed`)
      .then((data) => data.data);
  },
  followGroupKeys({commit}, payload: {id: number}) {
    return axiosInstance.post(`${baseUrl}/${payload.id}/keys-followed`)
      .then((data) => data.data);
  },
  unfollowGroupKeys({commit}, payload: {id: number}) {
    return axiosInstance.delete(`${baseUrl}/${payload.id}/keys-followed`)
      .then((data) => data.data);
  },
  getNonTransferables({commit}, payload: {id: number, params: object}) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/non-transferables`, {
      params: payload?.params,
    }).then((data) => data.data);
  },
  getKeyAccessByGroupId({commit}, payload: { id: number, params?: object }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/key-access`)
      .then((data) => data.data);
  },
  getKeyManagersSoloById({commit}, payload: { id: number, pagination: any }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/managers`, {params: {
        userGroupType: "user",
        ...payload.pagination,
      }}).then((data) => data.data);
  },
  getKeyManagersGroupsById({commit}, payload: { id: number, pagination: any }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/managers-groups`, {
      params: payload.pagination,
    }).then((data) => data.data);
  },
  getGuestsSoloById({commit}, payload: { id: number, pagination: any }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/guests`, {
      params: payload.pagination,
    }).then((data) => data.data);
  },
  getGuestsGroupsById({commit}, payload: { id: number, pagination: any }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/guests-groups`, {
      params: payload.pagination,
    }).then((data) => data.data);
  },
  addManagers({commit}, payload: { id: any, userGroups: any[] }) {
    return axiosInstance.post(`${baseUrl}/${payload.id}/managers`, {
      userGroups: payload.userGroups,
    }).then((data) => data.data);
  },
  addGuests({ commit }, payload: {
    id: number,
    userGroups: any[],
    userGroupsIds: any[],
    userGroupsData: any[],
    invitation: any,
  }) {
    return axiosInstance.post(`${baseUrl}/${payload.id}/guests`, {
      userGroups: payload.userGroups,
      userGroupsIds: payload.userGroupsIds,
      userGroupsData: payload.userGroupsData,
      invitation: payload.invitation,
    }).then((data) => data.data);
  },
  create({commit}, payload: { keyIds: number[], nonTransferableIds: number[], keyGroupData: object }) {
    return axiosInstance.post(`${baseUrl}/`, {
        ...payload.keyGroupData,
        keyIds: payload.keyIds,
        nonTransferableIds: payload.nonTransferableIds,
      }).then((data) => data.data);
  },
  update({commit}, payload: {id: number, data: any}) {
    return axiosInstance.put(`${baseUrl}/${payload.id}`, payload.data)
      .then((data) => data.data);
  },
  addKeys({commit}, payload: {id: number, keyIds: number }) {
    return axiosInstance.post(`${baseUrl}/${payload.id}/keys`, {
      keyIds: payload.keyIds,
    }).then((data) => data.data);
  },
  removeKey({commit}, payload: {groupId: number, keyId: number }) {
    return axiosInstance.delete(`${baseUrl}/${payload.groupId}/keys/${payload.keyId}`)
      .then((data) => data.data);
  },
  addNonTransferables({commit}, payload: {id: number, nonTransferableIds: number }) {
    return axiosInstance.post(`${baseUrl}/${payload.id}/non-transferables`, {
      nonTransferableIds: payload.nonTransferableIds,
    }).then((data) => data.data);
  },
  removeNonTransferable({commit}, payload: {groupId: number, nonTransferableId: number }) {
    return axiosInstance.delete(`${baseUrl}/${payload.groupId}/non-transferables/${payload.nonTransferableId}`)
      .then((data) => data.data);
  },
  giveHandToHand({commit}, payload: { keyGroupId: number, sourceUserId: number, targetUserId: number }) {
    return axiosInstance.post(`${baseUrl}/${payload.keyGroupId}/give-hand-to-hand`,
      {sourceUserId: payload.sourceUserId, targetUserId : payload.targetUserId})
      .then((data) => data.data);
  },
  checkHandToHand({commit}, payload: { keyGroupId: number, targetUserId: number }) {
    return axiosInstance.get(`${baseUrl}/${payload.keyGroupId}/check-hand-to-hand/${payload.targetUserId}`)
      .then((data) => data.data);
  },
  cancelHandToHand({commit}, payload: { keyGroupId: number, sourceUserId: number, targetUserId: number }) {
    return axiosInstance.post(`${baseUrl}/${payload.keyGroupId}/cancel-hand-to-hand`,
      {})
      .then((data) => data.data);
  },
  recoverHandToHand({commit}, payload: { keyGroupId: number, token: string}) {
    return axiosInstance.post(`${baseUrl}/${payload.keyGroupId}/recover-hand-to-hand`,
      {token: payload.token})
      .then((data) => data.data);
  },
  sendPin({commit}, payload: {
    keyGroupId: number,
    sourceUserId: number,
    targetUserId: number,
    acceptOverPrice: boolean,
    fromModal: boolean,
  }) {
    return axiosInstance.post(`${baseUrl}/${payload.keyGroupId}/send-sms`, {
      sourceUserId: payload.sourceUserId,
      targetUserId : payload.targetUserId,
      acceptOverPrice: payload.acceptOverPrice,
      fromModal: payload.fromModal,
    })
      .then((data) => data.data);
  },
  giveKeyGroupToGuest({commit}, payload: {
    keyGroupId: number,
    sourceRelayId: number,
    targetUserId: number,
    notificationType: string,
    acceptOverPrice: boolean,
    fromModal: boolean,
  }) {
    return axiosInstance.post(`${baseUrl}/${payload.keyGroupId}/give-key-groups-to-guest`, {
      sourceRelayId: payload.sourceRelayId,
      targetUserId : payload.targetUserId,
      notificationType : payload.notificationType,
      acceptOverPrice : payload.acceptOverPrice,
      fromModal : payload.fromModal,
    }).then((data) => data.data);
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
